export type PrintPaperFormat = "A2" | "A3" | "A4";
export type PrintTitleBlockMode = "standard" | "saved";
export type PrintColorMode = "canvas" | "monochrome" | "plot";

export interface PrintColorPreview {
  source: string;
  output: string;
  label: string;
}

export const printPaperOptions: PrintPaperFormat[] = ["A2", "A3", "A4"];

export const printColorModeOptions: Array<{ value: PrintColorMode; label: string }> = [
  { value: "canvas", label: "Canvas" },
  { value: "monochrome", label: "B/N" },
  { value: "plot", label: "Plot" },
];
